//import $ from 'jquery';
//import 'gsap';
//import '../main.js';
import {gsap} from "gsap";
import scroll from "./scroll";

const common = {
    $windowH: null,
    $windowW: null,
    $documentW: null,
    $windowInnerWidth: null,
    $windowW_actual: null,
    activSECTION: null,
    IN_VIEW: "accueil",
    smooth: null,
    disableSECTIONS: false,
    $sections: $('._section'),
    waypoint: null,
    movePlaceSection: false,
    links: null,

    checkLinks() {
        const _class_activ = "_activ_menu";
        const $_actual_activ = $(".barba-container").data("namespace");

        $(".__contain_menus").find("a").removeClass(_class_activ);
        $("a").removeClass(_class_activ);

        if ($_actual_activ === "expertises") {
            const _type = $("input[name=expertise_id]").val();
            if (_type !== "") {
                $("a[href][data-type=" + _type + "]").addClass(_class_activ);
                $(".a_menu[data-ex=" + _type + "]").addClass(_class_activ);
            }
        } else {
            $(".a_menu[data-menu=" + $_actual_activ + "]").addClass(_class_activ);
            $(".a_bottom[data-menu=" + $_actual_activ + "]").addClass(_class_activ);
        }
    },

    cbk(e) {
        const _class_activ = "_activ_menu";

        if (e.currentTarget.href === window.location.href) {
            e.preventDefault();
            e.stopPropagation();
        } else {
            $("a").removeClass(_class_activ);
            const _menu = $(e.currentTarget).data("menu");

            if (_menu === "expertises") {
                const _type = $(e.currentTarget).data("ex");
                if (_type !== "") {
                    $(".a_menu[data-ex=" + _type + "]").addClass(_class_activ);
                }
            } else {
                $(".a_menu[data-menu=" + _menu + "]").addClass(_class_activ);
                $(".a_bottom[data-menu=" + _menu + "]").addClass(_class_activ);
            }
        }
    },

    init() {

        this.links = document.querySelectorAll('a[href]');
        for (let i = 0; i < this.links.length; i++) {
            this.links[i].addEventListener('click', this.cbk.bind(this));
        }

        $("input[type='tel']").keyup(function () {
            $(this).val($(this).val().replace(/^\d{10}$/, "$1 $2 $3 $4 $5"));
        });

        this.getWINDOW();
    },

    goTOP() {
        if(scroll.locomotiveScroll){
            scroll.locomotiveScroll.scrollTo(0);
        }else{
                gsap.to($("html,body"), {
                    scrollTop: 0,
                    duration: .6
                });
        }
    },

    getWINDOW() {
        this.$windowH = $(window).height();
        this.$windowInnerHeight = $(window).innerHeight();
        this.$windowW = $(window).width();
        this.$documentW = $(document).width();
        this.$windowInnerWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

        if (this.$windowW_actual !== this.$windowW) {
            this.$windowW_actual = this.$windowW;
        }
    },

    trim(name, length) {
        return name.length > length ? name.substring(0, length) + " ..." : name;
    },

    wichTransitionEvent() {
        const el = document.createElement("fakeelement");
        const transitions = {
            "transition": "transitionend",
            "OTransition": "oTransitionEnd",
            "MozTransition": "transitionend",
            "WebkitTransition": "webkitTransitionEnd"
        };
        for (let t in transitions) {
            if (el.style[t] !== undefined) {
                return transitions[t];
            }
        }
    }
};

export default common;
